import { render } from "./vstencil.vue?vue&type=template&id=56f672b3"
import script from "./vstencil.vue?vue&type=script&lang=js"
export * from "./vstencil.vue?vue&type=script&lang=js"

import "./vstencil.vue?vue&type=style&index=0&id=56f672b3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__